import { ReactComponent as LogoSVG } from "../assets/logo.svg"

import './MainLogo.sass'

export default function MainLogo() {
  return <div className='MainLogo'><LogoSVG className="AlexxAndAnton" /></div>
}